import React, { useEffect, useRef } from 'react'
import { Badge, ListItem } from '@material-ui/core'
import moment from 'moment'
import './Message.css'

function ActiveSubjects({
    sellerMessages,
    activeProjectIndex,
    isArchive,
    onClick,
    phrase,
    handleArchiveButtonClick,
    handleUnarchiveButtonClick,
}) {
    const hasAutoLoaded = useRef(false)
    useEffect(() => {
        if (
            sellerMessages?.projectmessages?.length > 0 &&
            activeProjectIndex === '' &&
            !hasAutoLoaded.current
        ) {
            hasAutoLoaded.current = true
            const firstProject = sellerMessages.projectmessages[0]
            onClick(
                null,
                0,
                sellerMessages.sellerid,
                sellerMessages.messageunreadcount - firstProject.unreadcount,
                firstProject.project_id,
                true,
            )
        }
    }, [sellerMessages, activeProjectIndex, onClick])

    return (
        <ul className="activeSubjects">
            {sellerMessages?.projectmessages?.length > 0 ? (
                sellerMessages.projectmessages.map((projectMessage, index) => (
                    <ListItem
                        button
                        key={projectMessage.project_id}
                        onClick={(e) =>
                            onClick(
                                e,
                                index,
                                sellerMessages.sellerid,
                                sellerMessages.messageunreadcount - projectMessage.unreadcount,
                                projectMessage.project_id,
                                true,
                            )
                        }
                        className={activeProjectIndex === index ? 'active' : ''}
                    >
                        <div className="d-flex justify-content-between flex-wrap w-100">
                            <div className="subjectContent d-flex justify-content-between w-100">
                                <h4 className="asTitle">{projectMessage.title}</h4>
                                <h6>{moment(projectMessage.date_sent).format('DD-MM-YYYY')}</h6>
                            </div>
                            <div className="asContent d-flex justify-content-between w-100">
                                <h5 className="asSubject">
                                    {projectMessage.conversationcount + ' ' + phrase.conversations}
                                </h5>
                                <div className="d-flex justify-content-end">
                                    {isArchive ? (
                                        <a
                                            onClick={(e) => {
                                                e.stopPropagation()
                                                handleUnarchiveButtonClick(
                                                    sellerMessages.sellerid,
                                                    projectMessage.project_id,
                                                )
                                            }}
                                        >
                                            <span className="material-icons">unarchive</span>
                                        </a>
                                    ) : (
                                        <a
                                            onClick={(e) => {
                                                e.stopPropagation()
                                                handleArchiveButtonClick(
                                                    sellerMessages.sellerid,
                                                    projectMessage.project_id,
                                                )
                                            }}
                                        >
                                            <span className="material-icons">archive</span>
                                        </a>
                                    )}
                                    {projectMessage.unreadcount > 0 && (
                                        <Badge badgeContent={projectMessage.unreadcount}></Badge>
                                    )}
                                </div>
                            </div>
                        </div>
                    </ListItem>
                ))
            ) : (
                <div className="noSelection seller">
                    <div className="text-center">
                        <span className="material-icons">person</span>
                        <h4>No Seller Selected</h4>
                        <h6>Select a seller to view conversations</h6>
                    </div>
                </div>
            )}
        </ul>
    )
}

export default ActiveSubjects
